import styled from 'styled-components'

export const Container = styled.div``

export const ContainerTitle = styled.div`
  justify-content: start;
  align-items: start;
  margin: 50px 0 50px;
`
export const Table = styled.table`
  width: 100%;
  border-spacing: 0px 8px;
  margin-top: -8px;
  @media (min-width: 825px) {
    tbody {
      background-color: var(--box-background);
      border-radius: 5px;
      padding: 32px 32px 24px 32px;
    }
  }
  thead th {
    color: var(--dark-text-color);
    font-size: 15px;
    font-weight: 400;
    text-align: left;
    padding-left: 15px;
    padding-bottom: 5px;
  }
  thead th:first-child {
    padding-left: 0;
  }
  tbody tr {
    border-radius: 5px;
    background-color: var(--hover-gray);
  }
  tbody tr td:first-child {
    border-radius: 5px 0px 0px 5px;
  }
  tbody tr td:last-child {
    border-radius: 0px 5px 5px 0px;
    padding-bottom: 16px;
  }
  tbody tr td {
    color: var(--primary);
    font-size: 16px;
    padding: 16px;
  }
  @media (max-width: 825px) {
    border-spacing: 0px;
    thead {
      display: none;
    }
    tbody tr {
      display: flex;
      flex-direction: column;
      padding: 16px;
      border-radius: 5px;
    }
    tbody tr + tr {
      margin-top: 8px;
    }
    tbody tr td + td {
      margin-top: 0.75em;
    }
    tbody tr td,
    button {
      padding: 0px;
    }
    tbody tr td:first-child {
      border-radius: 5px 0px 0px 5px;
    }
    tbody tr td:last-child {
      border-radius: 0px 5px 5px 0px;
      padding-bottom: 0;
    }
    tbody tr td::before {
      content: attr(data-label);
      display: block;
      font-size: 13px;
      color: rgb(115, 115, 128);
      margin-bottom: 0.25em;
    }
  }
`
